import React from "react";
import {
  ComposedChart,
  AreaChart,
  Line,
  CartesianGrid,
  XAxis,
  YAxis,
  Tooltip,
  Area,
} from "recharts";
import { format } from "date-fns";
import Loading from "./Loading";
import closeIcon from "../images/close.png";

const styles = {
  background: {
    position: "fixed",
    top: 0,
    right: 0,
    zIndex: 2,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: "100%",
    height: "100%",
    background: "rgba(43,148,200,.3)",
  },
  container: {
    position: "relative",
    width: 800,
    height: 420,
    background: "#EEEEEE",
    padding: 15,
  },
  title: {
    color: "#496587",
    fontSize: 20,
    fontWeight: "normal",
    marginBottom: 50,
    textTransform: "capitalize",
  },
  dateButton: {
    marginRight: 15,
    background: "white",
    border: 0,
    borderRadius: 3,
    color: "#496587",
    cursor: "pointer",
    fontSize: 13,
    fontWeight: 700,
    padding: "3px 10px",
  },
  selectedDateButton: {
    marginRight: 15,
    border: 0,
    borderRadius: 3,
    color: "white",
    cursor: "pointer",
    fontSize: 13,
    fontWeight: 700,
    padding: "3px 10px",
    backgroundColor: "#496587",
  },
  dateButtonContainer: {
    display: "flex",
    listStyle: "none",
  },
  closeButton: {
    position: "absolute",
    top: -10,
    right: -10,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: 42,
    height: 42,
    background: "white",
    border: 0,
    borderRadius: "50%",
    boxShadow: "0 0 10px 0px #496587",
    cursor: "pointer",
  },
  chartPlaceholder: {
    height: 250,
  },
};

function getButtonStyle(value, index) {
  return value === index ? styles.selectedDateButton : styles.dateButton;
}

export default function Chart({
  data,
  market,
  title,
  setSelectedDate,
  closeChart,
  isLoading,
  selectedDateIndex,
}) {
  const isCBOT = market.name === "CBOT";
  console.log({ data });
  return (
    <div style={styles.background}>
      <div style={styles.container}>
        {isLoading ? <Loading /> : ""}
        <button type="button" onClick={closeChart} style={styles.closeButton}>
          <img src={closeIcon} alt="bezárás ikon" />
        </button>
        <h2 style={styles.title}>{title}</h2>
        {data.length ? (
          <ComposedChart
            width={705}
            height={250}
            data={data}
            margin={{ top: 5, right: 20, bottom: 5, left: 0 }}
          >
            <defs>
              <linearGradient id="colorUv" x1="0" y1="0" x2="0" y2="1">
                <stop offset="5%" stopColor="#2B94C8" stopOpacity={0.2} />
                <stop offset="95%" stopColor="#FFFFFF" stopOpacity={0.3} />
              </linearGradient>
            </defs>
            <Area
              type="monotone"
              strokeWidth={1.5}
              stroke={"#2B94C8"}
              dot={false}
              activeDot={{ fill: "red" }}
              connectNulls={true}
              dataKey="ár"
              strokeWidth={1.5}
              fillOpacity={1}
              fill="url(#colorUv)"
            />
            <CartesianGrid stroke="#cccccc" vertical={false} />
            <XAxis
              dataKey="date"
              tickFormatter={(value) => format(new Date(value), "MM.dd")}
              axisLine={false}
              tickLine={false}
            />
            <YAxis
              domain={[
                (dataMin) => Math.round(dataMin - 5),
                (dataMax) => Math.round(dataMax + 5),
              ]}
              label={{
                value: `${isCBOT ? "Dollár / véka" : "Euró / tonna"}`,
                angle: -90,
              }}
              axisLine={false}
              tickLine={false}
              width={140}
              tickCount={6}
            />
            <Tooltip
              cursor={{ stroke: "black", strokeWidth: 1.5 }}
              formatter={(value, name, props) =>
                `${value} ${isCBOT ? "$ / v" : "€ / t"}`
              }
              labelFormatter={(value, name, props) =>
                `dátum: ${format(new Date(value), "yyyy.MM.dd")}`
              }
              itemStyle={{ color: "#302f2b", fontSize: 13 }}
            />
          </ComposedChart>
        ) : (
          <div style={styles.chartPlaceholder}></div>
        )}
        <ul style={styles.dateButtonContainer}>
          <li>
            <button
              style={getButtonStyle(0, selectedDateIndex)}
              type="button"
              value={0}
              onClick={setSelectedDate}
            >
              Teljes időszak
            </button>
          </li>
          <li>
            <button
              style={getButtonStyle(1, selectedDateIndex)}
              type="button"
              value={1}
              onClick={setSelectedDate}
            >
              1 év
            </button>
          </li>
          <li>
            <button
              style={getButtonStyle(2, selectedDateIndex)}
              type="button"
              value={2}
              onClick={setSelectedDate}
            >
              Fél év
            </button>
          </li>
          <li>
            <button
              style={getButtonStyle(3, selectedDateIndex)}
              type="button"
              value={3}
              onClick={setSelectedDate}
            >
              3 hónap
            </button>
          </li>
          <li>
            <button
              style={getButtonStyle(4, selectedDateIndex)}
              type="button"
              value={4}
              onClick={setSelectedDate}
            >
              1 hónap
            </button>
          </li>
        </ul>
      </div>
    </div>
  );
}
